<template>
  <div>
    <b-card
      id="pdfGenerateDiv"
      ref="pdfGenerateDivRef"
      no-body
      class="invoice-preview-card p-1 main-table"
    >
      <div>
        <div
          class="card__inner"
        >
          <table style="width: 100%; page-break-after: auto; border-collapse:separate; border-spacing: 10px 5px;">
            <thead>
              <tr>
                <td>
                  <b-card-body class="invoice-padding pb-0">
                    <div
                      class="
                            d-flex
                            justify-content-between
                            flex-md-row flex-column
                            invoice-spacing
                            mt-0
                          "
                    >
                      <!-- Header: Left Content -->
                      <div>
                        <div class="logo-wrapper">
                          <img
                            style="height:60px;object-fit:contain;"
                            :src="purchaseRequest.company ? (purchaseRequest.company.logo ? purchaseRequest.company.logo : '/nirvana-memorial-garden-logo.png') : '/nirvana-memorial-garden-logo.png'"
                            alt="Logo"
                            crossorigin="anonymous"
                          >
                        </div>
                      </div>

                      <div
                        class="px-2"
                      >
                        <h4 style="text-align: center; text-transform: uppercase; color: #000000; font-weight: bold; font-size: 12px; line-height: 18px;">
                          Purchase Requisition form (PRF)
                        </h4>
                      </div>
                      <div class="mt-md-0 mt-2 text-right">
                        <h4
                          class="invoice-title"
                          style="font-size: 12px;line-height: 21px;color: #104D9D; margin:0; font-weight:bold"
                        >
                          {{ purchaseRequest.prID }}
                        </h4>
                        <div class="invoice-date-wrapper">
                          <p
                            class="invoice-date"
                            style="font-weight: normal !important;font-size: 11px;line-height: 16px; margin:0;"
                          >
                            <span
                              class="semi-bold"
                              style="font-weight:bold"
                            >Requested By:</span>
                            {{ purchaseRequest.createdBy ? purchaseRequest.createdBy.name : '' }}, {{ purchaseRequest.department ? purchaseRequest.department.name : '' }}
                          </p>
                        </div>
                        <div class="invoice-date-wrapper">
                          <p
                            class="invoice-date"
                            style="font-weight: normal !important;font-size: 11px;line-height: 16px; margin:0;"
                          >
                            <span
                              class="semi-bold"
                              style="font-weight:bold"
                            >Created On:</span> {{ dateFormatWithTime(purchaseRequest.createdAt) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card-body>

                  <!-- Spacer -->
                  <hr
                    class="invoice-spacing"
                    style="margin-top:25px!important"
                  >
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <!-- Invoice Client & Payment Details -->
                  <b-card-body class="invoice-padding pt-0 main__body">
                    <b-row class="invoice-spacing">
                      <!-- Col: Invoice To -->
                      <b-col
                        cols="12"
                        xl="12"
                        class="p-0"
                      >
                        <h6
                          class="mb-2"
                          style="font-weight:bold"
                        >
                          Requester Details
                        </h6>
                        <b-table-simple
                          borderless
                          responsive
                        >
                          <b-tbody>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Entity / Company
                              </b-th>
                              <b-td>{{ purchaseRequest.company ? purchaseRequest.company.name : '' }}</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Justification / Purpose of Purchase
                              </b-th>
                              <b-td>{{ purchaseRequest.purpose }}</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Required Delivery Date
                              </b-th>
                              <b-td>{{ dateFormat(purchaseRequest.deliveryDate) }}</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Deliver To
                              </b-th>
                              <b-td>{{ purchaseRequest.deliverTo ? purchaseRequest.deliverTo.name : '' }}</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Address
                              </b-th>
                              <b-td class="text-pre">{{ purchaseRequest.address }}
                              </b-td>
                            </b-tr>
                            <b-tr>
                              <b-th
                                style="font-weight:bold;"
                              >
                                Additional Remarks
                              </b-th>
                              <b-td class="text-pre">{{ purchaseRequest.remarks }}
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-col>
                      <b-col
                        cols="12"
                        class="p-0 item__description_table"
                      >
                        <!-- Invoice Description: Table -->
                        <table
                          style="page-break-after: auto; page-break-inside: avoid;"
                          class="pdf__table"
                        >
                          <thead style="display: table-header-group;">
                            <tr
                              role="row"
                              class="group__tag"
                            >
                              <th style="border-bottom: 1px solid #D2DCEA;">
                                No
                              </th>
                              <th style="border-bottom: 1px solid #D2DCEA;">
                                item description
                              </th>
                              <th style="border-bottom: 1px solid #D2DCEA;">
                                QTY
                              </th>
                              <th style="border-bottom: 1px solid #D2DCEA;">
                                Unit
                              </th>
                              <th style="border-bottom: 1px solid #D2DCEA;">
                                Est. total cost (S$)
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="purchaseRequestForm.items">
                            <tr
                              v-for="(item, index) in purchaseRequestForm.items"
                              :key="index"
                              style="page-break-inside: avoid; page-break-after: auto;"
                            >
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td style="max-width: 15rem;">
                                <div>
                                  <strong style="font-weight:bold;">{{ item.itemsMaster }}</strong>
                                  <br>
                                  <span class="text-pre">{{ item.description }}</span>
                                </div>
                              </td>
                              <td>
                                {{ item.quantity }}
                              </td>
                              <td>
                                {{ item.unit }}
                              </td>
                              <td>
                                {{ numberFormat(item.totalCost) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </td>
              </tr>
              <tr
                style="
                  width: 100%; page-break-before: auto;
                  page-break-after: auto;
                  page-break-inside: avoid;
                "
                class="footer-class-a"
              >
                <td>
                  <div class="foot">
                    <div :style="{ height: gapHeight+'mm' }" />
                    <div>
                      <!-- Spacer -->
                      <hr class="invoice-spacing">

                      <!-- Invoice Description: Total -->
                      <b-card-body class="invoice-padding pb-0 footer__area">
                        <div class="signatories_block">
                          <b-row>
                            <!-- Col: Sales Persion -->
                            <b-col
                              cols="3"
                              md="3"
                              class="mt-md-0 mt-3"
                              order="2"
                              order-md="1"
                            >
                              <b-card-text class="mb-0">
                                <span
                                  class="font-weight-bold"
                                  style="font-weight:bold"
                                >1. Requested By</span>
                                <div class="sign-box">
                                  <div v-if="purchaseRequestForm && purchaseRequestForm.createdBySign == true">
                                    <div v-if="purchaseRequest.createdBy && purchaseRequest.createdBy.signature">
                                      <b-img
                                        class="mb-1 mb-sm-0 user__avatar"
                                        height="40"
                                        crossorigin="anonymous"
                                        style="height:40px; width: 90%; object-fit:contain;"
                                        :src="purchaseRequest.createdBy.signature"
                                      />
                                    </div>
                                    <div v-else-if="purchaseRequest.createdBy && purchaseRequest.createdBy.name">
                                      <span>{{ purchaseRequest.createdBy.name }}</span>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <p>Pending Signature</p>
                                  </div>
                                </div>
                                <p
                                  class="ml-75 semi-bold"
                                  style="font-weight:bold;"
                                >
                                  {{ purchaseRequest.createdBy ? purchaseRequest.createdBy.name : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequest.department ? purchaseRequest.department.name : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.createdBySign == true ? dateFormatWithTime(purchaseRequestForm.createdBySignDate) : '-') : '-' }}
                                </p>
                              </b-card-text>
                            </b-col>
                            <b-col
                              cols="3"
                              md="3"
                              class="mt-md-0 mt-3"
                              order="2"
                              order-md="1"
                            >
                              <b-card-text class="mb-0">
                                <span
                                  class="font-weight-bold"
                                  style="font-weight: bold;"
                                >2. Confirmed By</span>
                                <div class="sign-box">
                                  <div v-if="purchaseRequestForm && purchaseRequestForm.confirmedBySign == true">
                                    <div v-if="purchaseRequestForm.confirmedBy && purchaseRequestForm.confirmedBy.signature">
                                      <b-img
                                        class="mb-1 mb-sm-0 user__avatar"
                                        height="40"
                                        crossorigin="anonymous"
                                        style="height:40px; width: 90%; object-fit:contain;"
                                        :src="purchaseRequestForm.confirmedBy.signature"
                                      />
                                    </div>
                                    <div v-else-if="purchaseRequestForm.confirmedBy && purchaseRequestForm.confirmedBy.name">
                                      <span>{{ purchaseRequestForm.confirmedBy.name }}</span>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <p>Pending Signature</p>
                                  </div>
                                </div>
                                <p
                                  class="ml-75 semi-bold"
                                  style="font-weight:bold;"
                                >
                                  {{ purchaseRequestForm ? (purchaseRequestForm.confirmedBy ? purchaseRequestForm.confirmedBy.name : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.confirmedBy ? (purchaseRequestForm.confirmedBy.department.length ? purchaseRequestForm.confirmedBy.department[0].name : '') : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.confirmedBySign == true ? dateFormatWithTime(purchaseRequestForm.confirmedBySignDate) : '-') : '-' }}
                                </p>
                              </b-card-text>
                            </b-col>
                            <b-col
                              cols="3"
                              md="3"
                              class="mt-md-0 mt-3"
                              order="2"
                              order-md="1"
                            >
                              <b-card-text class="mb-0">
                                <span
                                  class="font-weight-bold"
                                  style="font-weight: bold;"
                                >3. Approved By</span>
                                <div class="sign-box">
                                  <div v-if="purchaseRequestForm && purchaseRequestForm.approvedBySign == true">
                                    <div v-if="purchaseRequestForm.approvedBy && purchaseRequestForm.approvedBy.signature">
                                      <b-img
                                        class="mb-1 mb-sm-0 user__avatar"
                                        height="40"
                                        crossorigin="anonymous"
                                        style="height:40px; width: 90%; object-fit:contain;"
                                        :src="purchaseRequestForm.approvedBy.signature"
                                      />
                                    </div>
                                    <div v-else-if="purchaseRequestForm.approvedBy && purchaseRequestForm.approvedBy.name">
                                      <span>{{ purchaseRequestForm.approvedBy.name }}</span>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <p>Pending Signature</p>
                                  </div>
                                </div>
                                <p
                                  class="ml-75 semi-bold"
                                  style="font-weight:bold;"
                                >
                                  {{ purchaseRequestForm ? (purchaseRequestForm.approvedBy ? purchaseRequestForm.approvedBy.name : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.approvedBy ? (purchaseRequestForm.approvedBy.department.length ? purchaseRequestForm.approvedBy.department[0].name : '') : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.approvedBySign == true ? dateFormatWithTime(purchaseRequestForm.approvedBySignDate) : '-') : '-' }}
                                </p>
                              </b-card-text>
                            </b-col>
                            <b-col
                              cols="3"
                              md="3"
                              class="mt-md-0 mt-3"
                              order="2"
                              order-md="1"
                            >
                              <b-card-text class="mb-0">
                                <span
                                  class="font-weight-bold"
                                  style="font-weight: bold;"
                                >4. Verified By</span>
                                <div class="sign-box">
                                  <div v-if="purchaseRequestForm && purchaseRequestForm.assignedToSign == true">
                                    <div v-if="purchaseRequestForm.assignedTo && purchaseRequestForm.assignedTo.signature">
                                      <b-img
                                        class="mb-1 mb-sm-0 user__avatar"
                                        height="40"
                                        crossorigin="anonymous"
                                        style="height:40px; width: 90%; object-fit:contain;"
                                        :src="purchaseRequestForm.assignedTo.signature"
                                      />
                                    </div>
                                    <div v-else-if="purchaseRequestForm.assignedTo && purchaseRequestForm.assignedTo.name">
                                      <span>{{ purchaseRequestForm.assignedTo.name }}</span>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <p>Pending Signature</p>
                                  </div>
                                </div>
                                <p
                                  class="ml-75 semi-bold"
                                  style="font-weight:bold;"
                                >
                                  {{ purchaseRequestForm ? (purchaseRequestForm.assignedTo ? purchaseRequestForm.assignedTo.name : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.assignedTo ? (purchaseRequestForm.assignedTo.department.length ? purchaseRequestForm.assignedTo.department[0].name : '') : '') : '' }}
                                </p>
                                <p class="ml-75">
                                  {{ purchaseRequestForm ? (purchaseRequestForm.assignedToSign == true ? dateFormatWithTime(purchaseRequestForm.assignedToSignDate) : '-') : '-' }}
                                </p>
                              </b-card-text>
                            </b-col>
                          </b-row>
                        </div>
                      </b-card-body>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BImg, BCardText, VBTooltip, BTableSimple, BTbody,
  BTr, BTh, BTd, BCardBody,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BCardText,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BCardBody,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      elHeight: 0,
      gapHeight: 1,
      purchaseRequest: {},
      purchaseRequestForm: {},
    }
  },
  mounted() {
    this.$http.get(`download/purchase-request/${this.$route.params.id}/show`)
      .then(response => {
        this.purchaseRequest = response.data.data || {}
        this.purchaseRequestForm = response.data.prf || {}
        // this.calculateGapHeight()
      })
  },

  methods: {
    async calculateGapHeight() {
      await this.$nextTick()
      const pageHeight = document.documentElement.scrollHeight * 0.26
      console.log(pageHeight)
      // eslint-disable-next-line radix
      const totalPage = parseInt(pageHeight / 320)
      let gapHeight = 0
      if (totalPage === 0) {
        gapHeight = (320 - pageHeight)
      } else {
        gapHeight = ((320 * (totalPage + 1)) - pageHeight)
      }
      // console.log(gapHeight)
      this.gapHeight = gapHeight
    },
  },
}
</script>

<style lang="scss">
    body div#app.semi-dark-layout {
        background: #fff !important;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        background-size: 100% auto !important;
    }
    body {
        background: #fff !important;
    }
    .card {
        box-shadow: none !important;
    }
</style>
<style>
    @media print {
        html, body {
            height: 99%;
        }
    }
</style>
